// extracted by mini-css-extract-plugin
module.exports = {"view":"_2QiRMBGPMmXTOVquzvvje8"};